import { api } from './index';

export interface SharedArtifact {
  id: string;
  moments_artifact_id: string;
  revision: number;
  title: string;
  markdown: string;
  profile_slug: string;
  owner_person_id: string;
  recipient_email: string;
  session_date: string | null;
  sources: Array<{ type: string; value: string; label?: string | null }>;
  shared_at: string;
  created_at: string;
}

export interface SharedArtifactBySessionParams {
  session_id: string;
}

export const sharedArtifactApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSharedArtifactBySession: builder.query<
      SharedArtifact | null,
      SharedArtifactBySessionParams
    >({
      providesTags: (_result, _error, { session_id }) => [
        { id: session_id, type: 'SharedArtifact' },
      ],
      query: ({ session_id }) => ({
        method: 'GET',
        params: { session_id },
        url: '/shared_artifacts/by_session',
      }),
    }),
  }),
});

export const { useGetSharedArtifactBySessionQuery } = sharedArtifactApi;
